import http, {objectToFormData} from './http';

export default {
  all() {
    return http().get(`/v1/recordings`);
  },
  create(data, validationErrors) {
    let formData = objectToFormData(data)
    return http(validationErrors).post(`/v1/recordings`, formData);
  },
  delete(id) {
    return http().delete(`/v1/recordings/${id}`);
  },
}
